class RectObject {
    constructor(x, y, width, height, game) {
        this.width = width;
        this.height = height;
        this.position = {
            x,
            y,
        };
        this.game = game
        this.fillStyle= "#000000"
    }

    draw() {
        this.game.ctx.fillStyle = this.fillStyle;
        this.game.ctx.fillRect(this.position.x, this.position.y, this.width, this.height);
    }
}

export default RectObject
